import { render, staticRenderFns } from "./ccv-simple-bar-chart.vue?vue&type=template&id=5ac72f36&"
import script from "./ccv-simple-bar-chart.vue?vue&type=script&lang=js&"
export * from "./ccv-simple-bar-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports